import { authFetch, formatLocalDateTime } from "./client";

export const dashboardKeys = {
  dailyWeekly: ["dashboard", "daily-weekly-revenue"],
  olderRevenue: ["dashboard", "older-revenue"],
  totalSales: ["dashboard", "total-transaction"],
  userOverview: ["dashboard", "user-overview"],
  walletBalance: ["dashboard", "wallet-balance"],
  yearly: ["dashboard", "annual-revenue-summary"],
  summary: ["dashboard", "monthly-summary"],
  meters: ["dashboard", "meters-by-disco"],
  transactions: (params) => ["dashboard", "transactions", params],
};

export const fetchDailyWeeklyRevenue = () =>
  authFetch("dashboard/daily-weekly-revenue");

export const fetchOlderRevenue = () => authFetch("dashboard/older-revenue");

export const fetchTotalSales = () => authFetch("dashboard/total-transaction");

export const fetchUserOverview = () => authFetch("dashboard/user-overview");

export const fetchWalletBalance = () =>
  authFetch("dashboard/wallet-balance");

export const fetchAnnualRevenue = () =>
  authFetch("dashboard/annual-revenue-summary");

export const fetchMonthlySummary = () =>
  authFetch("dashboard/monthly-summary");

export const fetchMetersByDisco = () =>
  authFetch("dashboard/meters/total-by-disco");

export const fetchTransactions = ({
  startDate,
  endDate,
  searcher = "",
  currentPage = 0,
}) => {
  const start = formatLocalDateTime(startDate);
  const end = formatLocalDateTime(endDate);
  return authFetch(
    `admin/all-transactions?search=${searcher}&startDate=${start}&endDate=${end}&page=${currentPage}`
  );
};
